import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

const SchoolOverviewTitle = () => {
  const { t } = useTranslation('common');
  return (
    <div className="school-overview-title">
      <h1 className="school-main-title h1">
        {t('service.school.effectiveClasses.header')}
      </h1>
      <h2 className="school-main-subtitle">
        {t('service.school.effectiveClasses.intro')}
      </h2>
      <div className="col-span-12 hidden sm:block sm:mb-8">
        <div className="media-photo bg-white">
          <Image
            fill
            className="flex-image"
            src="/images/tutoring.png"
            alt="Tutoring Image"
          />
        </div>
      </div>
    </div>
  );
};

export default SchoolOverviewTitle;
